import { createReducer } from '@reduxjs/toolkit';
import { GetGrpoData, GetGrpoItmData, PostedCoils, PostItemCoilId } from './grpoThunk';

// Utility function to handle pending, fulfilled, and rejected actions
const handleAsyncActions = (builder, action, dataKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[dataKey] = true;
      state[dataKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[dataKey] = false;
      state[dataKey] = action.payload;
      state.error[errorKey] = null;
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[dataKey] = false;
      state.error[errorKey] = action.payload;
    });
};

const initialState = {
  // Data for each API
  GetPoData: JSON.parse(sessionStorage.getItem('GetGrpoData')) || null,
  GrpoItmData: null,
  postResponse: null,
  PostedCoil:null,

  // Dynamic loading and error states for each API
  loading: {
    GetPoData: false,
    GrpoItmData: false,
    postResponse: false,
    PostedCoil:false,
  },

  error: {
    GetPoDataError: null,
    GrpoItmDataError: null,
    postResponseError: null,
    PostedCoilError:null,
  },
};

export const grpoReducer = createReducer(initialState, (builder) => {
  // Handle async actions using the utility function
  handleAsyncActions(builder, GetGrpoData, 'GetPoData', 'GetPoDataError');
  handleAsyncActions(builder, GetGrpoItmData, 'GrpoItmData', 'GrpoItmDataError');
  handleAsyncActions(builder, PostItemCoilId, 'postResponse', 'postResponseError');
  handleAsyncActions(builder, PostedCoils, 'PostedCoil', 'PostedCoilError');
});

export default grpoReducer;



// import { createReducer } from '@reduxjs/toolkit';
// // import { fetchGrpoData, postGrpoData } from './grporeduxthunk';  // assuming these are thunks
// import { GetGrpoData, GetGrpoItmData, PostItemCoilId } from './grpoThunk';

// const initialState = {
//   GetPoData: JSON.parse(sessionStorage.getItem('GetGrpoData')) || null,
//   GrpoItmData: null,
//   loading: false,
//   error: null,
//   postResponse: null,
// };

// export const grpoReducer = createReducer(initialState, (builder) => {
//   builder
//     // Handle pending state for fetchGrpoData (async)
//     .addCase(GetGrpoData.pending, (state) => {
//       state.loading = true;
//     })
//     // Handle fulfilled state for fetchGrpoData (async)
//     .addCase(GetGrpoData.fulfilled, (state, action) => {
//       state.loading = false;
//       state.GetPoData = action.payload;
//       sessionStorage.setItem('GetGrpoData', JSON.stringify(action.payload));
//       state.error = null;
//     })
//     // Handle rejected state for fetchGrpoData (async)
//     .addCase(GetGrpoData.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;

//     })
//     // Handle pending state for postGrpoData (async)
//     .addCase(GetGrpoItmData.pending, (state) => {
//       state.loading = true;
//     })
//     // Handle fulfilled state for postGrpoData (async)
//     .addCase(GetGrpoItmData.fulfilled, (state, action) => {
//       state.loading = false;
//       state.GrpoItmData = action.payload;
//       state.error = null;
//     })
//     // Handle rejected state for postGrpoData (async)
//     .addCase(GetGrpoItmData.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;
//     })
//     .addCase(PostItemCoilId.pending, (state) => {
//       state.loading = true;
//       state.postResponse = null;  // Reset post response before making the request
//     })
//     // Handle fulfilled state for PostItemCoilId (async)
//     .addCase(PostItemCoilId.fulfilled, (state, action) => {
//       state.loading = false;
//       state.postResponse = action.payload;  // Store the response data from the POST request
//       state.error = null;
//     })
//     // Handle rejected state for PostItemCoilId (async)
//     .addCase(PostItemCoilId.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.payload;  // Handle error from the POST request
//     });
// });

// export default grpoReducer;
